import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {
  PracticeChangeFormFertiliser,
  PracticeChangeFormPesticide,
  PracticeChangeFormWater
} from '../../services/practice-change.types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {RSValidatorFormDirective} from '../../../libs/rsvalidator/rsvalidator.directive';

@Component({
  selector: 'app-practice-change-pesticide',
  templateUrl: './practice-change-pesticide.component.html',
  styleUrls: ['./practice-change-pesticide.component.scss']
})
export class PracticeChangePesticideComponent extends RSDialogComponentModel implements OnInit, AfterViewInit {
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;

  public get input(): PracticeChangeFormPesticide {
    return (this.dialogValues?.inputs || new PracticeChangeFormPesticide());
  }

  constructor() {
    super();
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  save() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
